export default __webpack_public_path__ + "static/media/formas-digitales-banner-nosotros.7f69c3d1.png";